import { createReducer, on } from '@ngrx/store';
import { IBillingTransactions, IEMData } from '@dch/billing-business-logic';
import {
  getBillingTransactionsFailure,
  getBillingTransactionsRequest,
  getBillingTransactionsSuccess,
} from '../actions/billing-transactions.actions';

export interface BillingTransactionsState {
  byAccountNumber: {
    [accountNumber: string]: IEMData<IBillingTransactions>;
  };
}

export const initialState: BillingTransactionsState = {
  byAccountNumber: {},
};

export const billingTransactionsReducer = createReducer(
  initialState,
  on(getBillingTransactionsRequest, (state, { billingAccountNumber }) => ({
    ...state,
    byAccountNumber: {
      ...state.byAccountNumber,
      [billingAccountNumber]: {
        result: state.byAccountNumber[billingAccountNumber]?.result ?? null,
        hasError: false,
        isFetching: true,
      },
    },
  })),
  on(
    getBillingTransactionsSuccess,
    (state, { billingAccountNumber, transactions }) => ({
      ...state,
      byAccountNumber: {
        ...state.byAccountNumber,
        [billingAccountNumber]: {
          result: transactions,
          hasError: false,
          isFetching: false,
        },
      },
    })
  ),
  on(getBillingTransactionsFailure, (state, { billingAccountNumber }) => ({
    ...state,
    byAccountNumber: {
      ...state.byAccountNumber,
      [billingAccountNumber]: {
        result: null,
        hasError: true,
        isFetching: false,
      },
    },
  }))
);
